module.exports = __webpack_public_path__ + "img/mcphaulcenter-h-474x356.81b43a84.jpg";